import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import RichTextEditor from '../RichTextEditor';

interface ContentFormProps {
    ticket_group_code: string;
    is_SoldOut: boolean;
    post_date: string;
    buy_date: string;
    due_date: string;
    event_date_start: string;
    event_date_end: string;
    event_time_start: string;
    event_time_end: string;
    title: string;
    venue: string;
    body: string;
    url: string;
    banner_image: File | null;
    banner_image_name?: string;
    poster_image: File | null;
    poster_image_name?: string;
    thumbnail_image: File | null;
    thumbnail_image_name?: string;
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onPostDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBuyDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onDueDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onEventDateStartChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onEventDateEndChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onEventTimeStartChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onEventTimeEndChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onVenueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBodyChange: (content: string) => void;
    onUrlChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBannerImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onPosterImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onThumbnailImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSoldOutChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function ContentForm({
    ticket_group_code,
    is_SoldOut,
    post_date,
    buy_date,
    due_date,
    event_date_start,
    event_date_end,
    event_time_start,
    event_time_end,
    banner_image_name,
    thumbnail_image_name,
    poster_image_name,
    title,
    venue,
    body,
    url,
    onTicketGroupCodeChange,
    onPostDateChange,
    onBuyDateChange,
    onDueDateChange,
    onEventDateStartChange,
    onEventDateEndChange,
    onEventTimeStartChange,
    onEventTimeEndChange,
    onTitleChange,
    onVenueChange,
    onBodyChange,
    onUrlChange,
    onBannerImageChange,
    onPosterImageChange,
    onThumbnailImageChange,
    onSoldOutChange
}: ContentFormProps) {
    return (
        <>
            <div className="mb-4">
                <h2 className="GraphikSemibold text-[18px] text-[#1f2328] font-semibold mb-3">Content</h2>

                <Form.Group className="mb-3" controlId="formTitle">
                    <label className='text-sm mb-2'>Title</label>
                    <FloatingLabel controlId="floatingInput" label="Title" className="mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Title"
                            value={title}
                            className='bg-gray-200 pb-3'
                            onChange={onTitleChange}
                        />
                    </FloatingLabel>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formTicketGroupCode">
                    <label className='text-sm mb-2'>Ticket Group Code</label>
                    <FloatingLabel controlId="floatingInput" label="Ticket Group Code" className="mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Ticket Group Code"
                            value={ticket_group_code}
                            className='bg-gray-200'
                            onChange={onTicketGroupCodeChange}
                        />
                    </FloatingLabel>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formVenue">
                    <label className='text-sm mb-2'>Venue</label>
                    <FloatingLabel controlId="floatingInput" label="Venue" className="mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Venue"
                            value={venue}
                            className='bg-gray-200'
                            onChange={onVenueChange}
                        />
                    </FloatingLabel>
                </Form.Group>
            </div>
         
            <div className="mb-4">
                <h2 className="GraphikSemibold text-[18px] text-[#1f2328] font-semibold mb-3">Photos</h2>

                <Form.Group className="mb-3" controlId="formImage">
                    <Form.Label className='text-sm mb-2'>Banner Image (Resolution: 2500x882 px| Max Size: 2mb)</Form.Label>
                    <Form.Control type="file" className="mb-2" onChange={onBannerImageChange} />
                    {(banner_image_name) && (
                        <>
                            <Form.Text className="text-xsm text-muted d-block">Banner Image</Form.Text>
                            <Form.Text className="text-black d-block pb-3 hover:text-red-500">{banner_image_name ? <a href={`https://cdn.pulp.ph/storage/${banner_image_name}`} target="_blank" rel="noopener noreferrer">{banner_image_name}</a> : 'No Uploaded files on server'}</Form.Text>
                        </>
                    )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="formPosterImage">
                    <Form.Label className='text-sm mb-2'>Poster Image (Resolution: 900x1200 px| Max Size: 2mb)</Form.Label>
                    <Form.Control type="file" className="mb-2" onChange={onPosterImageChange} />
                    {(poster_image_name) && (
                        <>
                            <Form.Text className="text-xsm text-muted d-block">Poster Image</Form.Text>
                            <Form.Text className="text-black d-block pb-3 hover:text-red-500">{poster_image_name ? <a href={`https://cdn.pulp.ph/storage/${poster_image_name}`} target="_blank" rel="noopener noreferrer">{poster_image_name}</a> : 'No Uploaded files on server'}</Form.Text>
                        </>
                    )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="formThumbnailImage">
                    <Form.Label className='text-sm mb-2'>Thumbnail Image (Resolution: 500x469 px| Max Size: 2mb)</Form.Label>
                    <Form.Control type="file" className="mb-2" onChange={onThumbnailImageChange} />
                    {(thumbnail_image_name) && (
                        <>
                            <Form.Text className="text-xsm text-muted d-block">Thumbnail Image</Form.Text>
                            <Form.Text className="text-black d-block pb-3 hover:text-red-500">{thumbnail_image_name ? <a href={`https://cdn.pulp.ph/storage/${thumbnail_image_name}`} target="_blank" rel="noopener noreferrer">{thumbnail_image_name}</a> : 'No Uploaded files on server'}</Form.Text>
                        </>
                    )}
                </Form.Group>
            </div>

            <div className="mb-4">
                <h2 className="GraphikSemibold text-[18px] text-[#1f2328] font-semibold mb-3">Schedule & Information</h2>

                <Form.Group className="mb-3" controlId="formPostDate">
                    <label className='text-sm mb-2'>Post Date</label>
                    <FloatingLabel controlId="floatingInput" label="Post Date" className="mb-3">
                        <Form.Control
                            type="date"
                            placeholder="Post Date"
                            value={post_date ? new Date(post_date).toISOString().slice(0, 10) : ""}
                            className="bg-gray-200"
                            onChange={onPostDateChange}
                        />
                    </FloatingLabel>
                </Form.Group>

                <Form.Group className="mb-3">
                    <label className="text-sm mb-2">Selling Dates</label>
                    <div className="row">
                        <div className="col-md-6">
                            <FloatingLabel controlId="floatingBuyDate" label="Buy Date" className="mb-3">
                                <Form.Control
                                    type="date"
                                    placeholder="Buy Date"
                                    value={buy_date ? new Date(buy_date).toISOString().slice(0, 10) : ""}
                                    className="bg-gray-200"
                                    onChange={onBuyDateChange}
                                />
                            </FloatingLabel>
                        </div>
                        <div className="col-md-6">
                            <FloatingLabel controlId="floatingDueDate" label="Due Date" className="mb-3">
                                <Form.Control
                                    type="date"
                                    placeholder="Due Date"
                                    value={due_date ? new Date(due_date).toISOString().slice(0, 10) : ""}
                                    className="bg-gray-200"
                                    onChange={onDueDateChange}
                                />
                            </FloatingLabel>
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="mb-3">
                    <label className="text-sm mb-2">Event Dates</label>
                    <div className="row">
                        <div className="col-md-6">
                            <FloatingLabel controlId="floatingEventDateStart" label="Event Date Start" className="mb-3">
                                <Form.Control
                                    type="date"
                                    placeholder="Event Date Start"
                                    value={event_date_start ? new Date(event_date_start).toISOString().slice(0, 10) : ""}
                                    className="bg-gray-200"
                                    onChange={onEventDateStartChange}
                                />
                            </FloatingLabel>
                        </div>
                        <div className="col-md-6">
                            <FloatingLabel controlId="floatingEventDateEnd" label="Event Date End" className="mb-3">
                                <Form.Control
                                    type="date"
                                    placeholder="Event Date End"
                                    value={event_date_end ? new Date(event_date_end).toISOString().slice(0, 10) : ""}
                                    className="bg-gray-200"
                                    onChange={onEventDateEndChange}
                                />
                            </FloatingLabel>
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="mb-3">
                    <label className="text-sm mb-2">Event Time</label>
                    <div className="row">
                        <div className="col-md-6">
                            <FloatingLabel controlId="floatingEventTimeStart" label="Event Time Start" className="mb-3">
                                <Form.Control
                                    type="time"
                                    placeholder="Event Time Start"
                                    value={event_time_start}
                                    className="bg-gray-200"
                                    onChange={onEventTimeStartChange}
                                />
                            </FloatingLabel>
                        </div>
                        <div className="col-md-6">
                            <FloatingLabel controlId="floatingEventTimeEnd" label="Event Time End" className="mb-3">
                                <Form.Control
                                    type="time"
                                    placeholder="Event Time End"
                                    value={event_time_end}
                                    className="bg-gray-200"
                                    onChange={onEventTimeEndChange}
                                />
                            </FloatingLabel>
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBody">
                    <Form.Label className='text-sm mb-2'>Event Information</Form.Label>
                    <RichTextEditor value={body} onChange={onBodyChange} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formSoldOut">
                    <Form.Check
                        type="checkbox"
                        label="Sold Out"
                        checked={is_SoldOut}
                        onChange={onSoldOutChange}
                    />
                </Form.Group>
            </div>
   
            {/* <Form.Group className="mb-3" controlId="formUrl">
                <label className='text-sm mb-2'>Embed Url</label>
                <Form.Text className="text-muted d-block"> Sample Format: https://www.youtube.com/embed/F0cdbR5ognY?si=K5KZhV_jfVXWlKQe </Form.Text>
                <FloatingLabel controlId="floatingInput" label="URL" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Enter Youtube Embed Url"
                        value={url}
                        className='bg-gray-200'
                        onChange={onUrlChange}
                    />
                </FloatingLabel>
            </Form.Group> */}
        </>
    );
}
